import { render } from "./PublicBookingPage.vue?vue&type=template&id=715a0f2c&scoped=true"
import script from "./PublicBookingPage.vue?vue&type=script&lang=js"
export * from "./PublicBookingPage.vue?vue&type=script&lang=js"

import "./PublicBookingPage.vue?vue&type=style&index=0&id=715a0f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715a0f2c"]])

export default __exports__